import { render, staticRenderFns } from "./ArrowCard.vue?vue&type=template&id=e2bc84a4&scoped=true&"
import script from "./ArrowCard.vue?vue&type=script&lang=js&"
export * from "./ArrowCard.vue?vue&type=script&lang=js&"
import style0 from "./ArrowCard.vue?vue&type=style&index=0&id=e2bc84a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bc84a4",
  null
  
)

export default component.exports